module.exports = __webpack_public_path__ + "img/metting.fb74368f.png";